interface IProps {
    size?: string;
}

export const CoinIcon = (props: IProps) => {
    const { size } = props;

    return (
        <svg width={size || "22"} height={size || "22"} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5569" r="10" fill="url(#paint0_radial_6282_57364)" stroke="url(#paint1_linear_6282_57364)" />
            <path d="M15.5592 12.2512C15.6722 12.2512 15.7575 12.3502 15.7315 12.456C15.3177 14.1458 13.9539 15.3534 12.8102 15.9033C11.6207 16.4753 10.2762 16.6139 8.99936 16.2964C7.72248 15.9788 6.58978 15.224 5.78883 14.1571C4.98788 13.0901 4.56672 11.7749 4.5951 10.4293C4.62347 9.08374 5.09968 7.78842 5.94486 6.75787C6.79004 5.72733 7.9535 5.02338 9.24258 4.76258C10.5317 4.50179 11.869 4.69979 13.0333 5.32381C14.1567 5.92599 15.4461 7.05681 15.7477 8.81952C15.7653 8.92238 15.6811 9.01381 15.5729 9.01381H13.8743C13.7958 9.01381 13.7267 8.96459 13.7004 8.89336C13.382 8.03008 12.8328 7.52925 12.1057 7.13953C11.3454 6.73202 10.4721 6.60272 9.63024 6.77303C8.78843 6.94333 8.02866 7.40304 7.47673 8.07601C6.9248 8.74899 6.61382 9.59487 6.59529 10.4736C6.57676 11.3523 6.85179 12.2112 7.37484 12.9079C7.89788 13.6047 8.63757 14.0976 9.47141 14.3049C10.3053 14.5123 11.1832 14.4218 11.96 14.0483C12.6974 13.6937 13.3611 12.9846 13.6924 12.3517C13.7242 12.291 13.7879 12.2512 13.8586 12.2512H15.5592Z" fill="url(#paint2_linear_6282_57364)" />
            <defs>
                <radialGradient id="paint0_radial_6282_57364" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.4087 9.46123) rotate(89.5489) scale(11.596 12.8501)">
                    <stop stop-color="#F2CA3C" />
                    <stop offset="1" stop-color="#F2AA3C" />
                </radialGradient>
                <linearGradient id="paint1_linear_6282_57364" x1="16.0696" y1="20.6004" x2="2.92174" y2="3.52645" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C89137" />
                    <stop offset="1" stop-color="#FFF500" stop-opacity="0.2" />
                </linearGradient>
                <linearGradient id="paint2_linear_6282_57364" x1="8.53125" y1="13.8381" x2="22.9687" y2="-22.2556" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" />
                    <stop offset="0.900633" stop-color="white" stop-opacity="0.31" />
                </linearGradient>
            </defs>
        </svg>


    );
};
